// 农事日历
<template>
  <div class="main">
    <div class="header">{{ planInfo.projectName || '11' }}</div>
    <div class="content">
      <p>计划周期：{{ planInfo.planStart }}至{{ planInfo.planEnd }}</p>
      <p>任务抄送至：{{ planInfo.userNames || '--' }}</p>
      <p class="count">已完成：<span>{{ finisned }}</span></p>
      <p class="count">未完成：<span style="color:#F97980;">{{ planInfo.taskList ? planInfo.taskList.length - finisned :
        0 }}</span></p>

      <div class="echart" id="echart"></div>
      <el-collapse accordion @change="handleChange" v-model="active">
        <el-collapse-item v-for="(item, index) in planInfo.taskList" :key="index" :name="item.taskId">
          <template slot="title">
            <div class="title">
              <img v-if="item.taskState === '1'" src="@/assets/img/icon_finished.png">
              <img v-if="item.taskState === '0'" src="@/assets/img/icon_unfinished.png">
              <span>{{ item.taskNotes }}</span>
            </div>
          </template>
          <div v-if="item.taskId === active && detail.length > 0">
            <p>现场作业</p>
            <div class="work">
              <div v-for="(item, index) in detail" :key="index">
                <p>作业日期：{{ item.dailyDate || '--' }}&nbsp;&nbsp;&nbsp;&nbsp;提报人：{{ item.dailyUserName || '--' }}</p>
                <custom-upload v-model="item.fileList" disabled></custom-upload>
                <p>备注：{{ item.workNotes || '--' }}</p>
              </div>
            </div>
          </div>
          <NoData v-else></NoData>
        </el-collapse-item>
        <template v-if="finisned === 0">
          <el-button type="primary" v-show="$ButtonShow('YPR_DEL_01')" @click="onEdit">编辑</el-button>
          <el-button @click="onDelete" v-show="$ButtonShow('YPR_EDT_01')">删除</el-button></template>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import * as Echarts from 'echarts'
import NoData from '@/components/NoData.vue'
export default {
  components: {
    NoData
  },
  data () {
    return {
      planInfo: {},
      detail: {},
      active: ''
    }
  },
  computed: {
    planId () {
      return this.$route.params.planId
    },
    finisned () {
      if (this.planInfo.taskList) {
        return this.planInfo.taskList.filter((t) => t.taskState === '1').length
      }
      return 0
    }
  },
  created () {
    this._chart = null
    this.planId && this.getDetail()
  },
  methods: {
    getDetail () {
      this.$axios.get(this.$apis.operationmanage.selectYhDailyPlanByPlanId, {
        planId: this.planId
      }).then(res => {
        this.planInfo = res || []
        this.renderEchart(this.finisned, this.planInfo.taskList.length || 0)
      })
    },
    onEdit () {
      this.$router.push({ name: 'PlanReportEdit', params: { planId: this.planId } })
    },
    renderEchart (value, total) {
      this.$nextTick(() => {
        this._chart = Echarts.init(document.getElementById('echart'))
        const option = {
          series: [{
            name: '11',
            type: 'pie',
            clockWise: false,
            radius: ['75%', '100%'],
            itemStyle: {
              normal: {
                color: '#449BFF',
                shadowBlur: 0,
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                }
              }
            },
            hoverAnimation: false,
            data: [
              {
                value: value,
                label: {
                  normal: {
                    formatter: (params) => {
                      return '{title' + `|${(+params.value / total * 100).toFixed(1)}` + '%}' + '\n' + '{name|完成率}'
                    },
                    rich: {
                      name: {
                        color: '#666666',
                        fontSize: 12,
                        lineHeight: 20
                      }
                    },
                    position: 'center',
                    show: true,
                    textStyle: {
                      fontSize: 26,
                      color: '#449BFF'
                    }
                  }
                }
              },
              {
                value: total === 0 ? 100 : total - value,
                name: 'invisible',
                itemStyle: {
                  normal: {
                    color: '#E0E0E0'
                  }
                }
              }
            ]
          }]
        }
        this._chart.clear()
        this._chart.setOption(option)
      })
    },
    onDelete () {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.operationmanage.deleteYhDailyPlan, { planId: this.planId }).then(() => {
          this.$message.success('删除成功')
          this.$router.back()
        })
      })
    },
    handleChange (val) {
      this.detail = []
      if (val) {
        this.$axios.get(this.$apis.operationmanage.selectYhDailyWorkByList, { taskId: val }).then((res) => {
          this.detail = res || []
        })
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.main {
  background: #fff;
}

.header {
  display: flex;
  align-items: center;
  height: 64px;
  padding-left: 20px;
  background: #F4F7FA;
  border: 1px solid #D0D0D0;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 28px;
  font-style: normal;
}

.content {
  position: relative;
  padding: 20px;

  p {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 22px;
    font-style: normal;
    margin-bottom: 20px;

    &.count {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #565656;
      font-style: normal;

      span {
        color: #89D762;
      }
    }
  }
}

::v-deep {
  .el-collapse {
    margin: 30px 0 30px 30px;
    border: 0;

    .el-collapse-item {
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 30px;
      }
    }

    .el-collapse-item__header {
      position: relative;
      height: auto;
      background: #FAFAFA;
      border: 1px solid #EBEBEB;
      padding: 10px 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      line-height: 30px;
      color: #000000;

      img {
        position: absolute;
        left: -30px;
        top: 20px;
      }
    }

    .el-collapse-item__content {
      background: #FFFFFF;
      border: 1px solid #EBEBEB;
      padding: 20px;
      border-bottom: 0;
      border-top: 0;
    }
  }
}

.el-button {
  margin-top: 30px;
}

.echart {
  position: absolute;
  width: 138px;
  height: 138px;
  right: 30px;
  top: 20px;
}

.work {
  display: flex;
  flex-wrap: wrap;

  >div {
    width: 50%;
  }
}
</style>
